<template>
    <div v-if="ctf_id" :style="{ 'min-height': smAndDown ? 'unset' : '54px' }">
        <div class="top-banner"
        :class="'top-banner ' + (this.fields && this.fields.background ? this.fields.background:'white')">
            <v-img
              v-if="file"
              :src="file.url"
              class="top-banner-image"
            />
            <div class="top-banner-text" :style="{ 'min-height': smAndDown ? 'unset' : '54px' }">
              <ctf-rich-text v-if="fields.bannerText" :document="fields.bannerText" />
            </div>
        </div>
    </div>
</template>
<script>
import { mapState } from 'vuex'
import { backgroundColorClass, textColorClass } from '@/utils/helpers'
import { queryEntryCTF, getCTFAsset } from '@/plugins/contentful'
import CtfRichText from '@/components/snippets/ctf-rich-text/ctf-rich-text'

export default {
  name: 'TopBanner',
  components: {
    CtfRichText
  },
  async mounted () {
    const { fields } = await queryEntryCTF(this.ctf_id)
    this.fields = fields
    this.image_id = this.fields.image[0].sys.id
  },
  data () {
    return {
      fields: [],
      image_id: null
    }
  },
  props: {
    assets: {
      type: Array,
      default: null
    },
    ctf_id: {
      type: String,
      default: null
    }
  },
  methods: {
    backgroundColorClass,
    textColorClass
  },
  computed: {
    ...mapState({ siteConfig: state => state.site.siteConfig }),
    file () {
      if (!this.fields || !this.assets) {
        return
      }
      const asset = getCTFAsset(this.image_id, this.assets)
      return asset
        ? {
          url: asset.fields.file.url,
          title: asset.fields.title
        } : null
    },
    smAndDown () {
      return this.$vuetify.breakpoint.smAndDown
    }
  }
}
</script>

<style lang="scss" scoped>
@import "src/styles/variables";
.top-banner {
  display: grid;
  justify-content: center;
  align-content: center;
  align-items: center;
  grid-auto-flow: column;
  text-align: center;

    &.white {
      background-color: $white !important;
      color: $black !important;
    }

    &.orange {
      background-color: $dorange !important;
      color: $white !important;
    }

    &.gold {
      background-color: $gold !important;
      color: $black !important;
    }

    &.dark-blue {
      background-color: $primary !important;
      color: $white !important;
    }

    &.light-blue {
      background-color: $light-primary !important;
      color: $black !important;
    }
    &.error {
      background-color: $red !important;
      color: $white !important;
    }
    &.warning {
      background-color: $warning !important;
      color: $white !important;
    }
}
.top-banner-image {
  width: 180px;
  height: auto;
}
.top-banner-text {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 18px;
  margin-top: 3px;
}

</style>
